import type { DefaultValues } from 'react-hook-form';

import type { FieldValuesRatioCreateOrEditStructure } from '../types';

export const DefaultFromValues: DefaultValues<FieldValuesRatioCreateOrEditStructure> = {
    kozp: '1.00',
    kem: '1.00',
    knr: '1.00',
    ksp: '1.00',
    kmat: '1.00',
    ktz: '1.00',
    ktzzpm: '1.00',
};
